module.exports = __webpack_public_path__ + "img/Card_Block_Yellow-min.3e313749.png";